import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { Component, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Router } from '@angular/router';
import { RoutesTable } from '@toro/common/shared/resources/routes-table.model';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { HomeStatus } from '@toro/common/shared/enum/home-status.enum';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';
import { IDENTIFICADA_STEP, IDENTIFICADA_STEP_LABEL, IDENTIFICADA_TRACKING } from '../home-identificada.tracking';

@Component({
    selector: 'home-logged-user-not-filling',
    templateUrl: './home-logged-user-not-filling.component.html',
    styleUrls: ['./home-logged-user-not-filling.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [],
})
export class HomeLoggedUserNotFillingComponent implements OnInit {
    public isNewBrand: boolean = environment.isNewBrand

    public registrationAppUrl: string;
    public tooltips: {[prop: string]: string} = {};

    /* Observables */
    public authentication$: Observable<any>;

    constructor(
        private store: Store<AppState>,
        private settingsService: SettingsService,
    ) {
        this.authentication$ = this.store.select((state) => state.authentication);

        // URL da página de cadastro
        this.registrationAppUrl = this.settingsService.getConfigurationKeyValue('rau');
     }

    public ngOnInit() {
        this.sendTracking(ActionEventsEnum.PAGE_LOADED, {
            'Product Area Origin': IDENTIFICADA_TRACKING.productAreaOrigin,
            'Status': IDENTIFICADA_TRACKING.status,
            'Step': IDENTIFICADA_STEP.cadastroNaoIniciado,
            'Time Responsável': IDENTIFICADA_TRACKING.timeResponsavel,
        });
    }

    public sendTracking(event: string, breakdowns: Record<string, unknown>) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }

    public onCtaClick(element: string) {
        this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
            'Product Area Origin': IDENTIFICADA_TRACKING.productAreaOrigin,
            'Status': IDENTIFICADA_TRACKING.status,
            'Step': IDENTIFICADA_STEP.cadastroNaoIniciado,
            'Label': IDENTIFICADA_STEP_LABEL[IDENTIFICADA_STEP.cadastroNaoIniciado],
            'Element': element,
            'Time Responsável': IDENTIFICADA_TRACKING.timeResponsavel,
        });
    }

    public scrollInterationClickButtom() {
        const body = $('html, body');
        const scrollTopElement = $('#doubts-section')
            .offset().top;

        body.animate(
            { scrollTop: scrollTopElement },
            700,
        );
    }
}
